import AlphabetizerIcon from "public/img/icons/tools/alphabetizer.svg";
import AssignmentCalculatorIcon from "public/img/icons/tools/assignment-calculator.svg";
import CaseConverterIcon from "public/img/icons/tools/title-case-converter.svg";
import CitationGeneratorIcon from "public/img/icons/tools/citation-generator.svg";
import ConclusionGeneratorIcon from "public/img/icons/tools/conclusion-generator.svg";
import EssayMakerIcon from "public/img/icons/tools/essay-maker.svg";
import EssayTitleGeneratorIcon from "public/img/icons/tools/essay-title-generator.svg";
import GraderCalculatorIcon from "public/img/icons/tools/grade-calculator.svg";
import GrammarCheckerIcon from "public/img/icons/tools/grammar-checker.svg";
import ParaphrasingIcon from "public/img/icons/tools/paraphrasing-tool.svg";
import PlagiarismIcon from "public/img/icons/tools/plagiarism-checker.svg";
import ReadabilityCheckerIcon from "public/img/icons/tools/readability-checker.svg";
import SpellCheckerIcon from "public/img/icons/tools/spell-checker.svg";
import SummarizerIcon from "@/public/img/icons/tools/summarizer-tool.svg";
import ThesisStatementIcon from "public/img/icons/tools/thesis-statement-generator.svg";
import WordCounterIcon from "public/img/icons/tools/word-counter-tool.svg";
import WordToPagesIcon from "public/img/icons/tools/words-to-pages-converter.svg";
import TitlePageGeneratorIcon from "public/img/icons/tools/title-page-generator.svg";
import AllIcon from "public/img/icons/tools/all.svg";

import CategoriesArtIcon from "public/img/icons/categories-art.svg";
import CategoriesBusinessIcon from "public/img/icons/categories-business.svg";
import CategoriesInformationTechnologyIcon from "public/img/icons/categories-information-technology.svg";
import CategoriesLawIcon from "public/img/icons/categories-law.svg";
import CategoriesOtherIcon from "public/img/icons/categories-other.svg";
import CategoriesSciencesIcon from "public/img/icons/categories-sciences.svg";
import CategoriesSocialSciencesIcon from "public/img/icons/categories-social-sciences.svg";
import EssayRewriterIcon from "public/img/icons/tools/essay-rewriter.svg";
import EssayTopicGeneratorIcon from "public/img/icons/tools/essay-topic-generator.svg";
import EssayTyperIcon from "public/img/icons/tools/essay-typer.svg";
import WordsToMinutesConverterIcon from "public/img/icons/tools/words-to-minutes-converter.svg";
import WritingPromptGeneratorIcon from "public/img/icons/tools/writing-prompt-generator.svg";

import AssignmentCalendarIcon from "public/img/icons/tools/assignment-calendar.svg";
import PaperGraderIcon from "public/img/icons/tools/paper-grader.svg";
import WebsiteCitationGeneratorIcon from "public/img/icons/tools/cite-a-website.svg";

export const iconDict: {
  [key: string]: React.SVGProps<SVGSVGElement>;
} = {
  all: AllIcon,
  alphabetizer: AlphabetizerIcon,
  "assignment-calculator": AssignmentCalculatorIcon,
  "assignment-calendar": AssignmentCalendarIcon,
  "paper-grader": PaperGraderIcon,
  "title-case-converter": CaseConverterIcon,
  "citation-generator": CitationGeneratorIcon,
  "conclusion-generator": ConclusionGeneratorIcon,
  "essay-maker": EssayMakerIcon,
  "essay-rewriter": EssayRewriterIcon,
  "essay-title-generator": EssayTitleGeneratorIcon,
  "essay-topic-generator": EssayTopicGeneratorIcon,
  "essay-typer": EssayTyperIcon,
  "grade-calculator": GraderCalculatorIcon,
  "grammar-checker": GrammarCheckerIcon,
  "paraphrasing-tool": ParaphrasingIcon,
  "plagiarism-checker": PlagiarismIcon,
  "readability-checker": ReadabilityCheckerIcon,
  "spell-checker": SpellCheckerIcon,
  "summarizer-tool": SummarizerIcon,
  "thesis-statement-generator": ThesisStatementIcon,
  "word-counter-tool": WordCounterIcon,
  "words-to-pages-converter": WordToPagesIcon,
  "title-page-generator": TitlePageGeneratorIcon,
  "words-to-minutes-converter": WordsToMinutesConverterIcon,
  "writing-prompt-generator": WritingPromptGeneratorIcon,
  "cite-a-website": WebsiteCitationGeneratorIcon,

  "categories-art": CategoriesArtIcon,
  "categories-business": CategoriesBusinessIcon,
  "categories-information-technology": CategoriesInformationTechnologyIcon,
  "categories-law": CategoriesLawIcon,
  "categories-other": CategoriesOtherIcon,
  "categories-sciences": CategoriesSciencesIcon,
  "categories-social-sciences": CategoriesSocialSciencesIcon,
};
